import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-cream" data-id="element-102">
      <div className="max-w-4xl mx-auto" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-104">
          <span className="text-sm font-bold tracking-widest text-text-medium uppercase mb-4 block" data-id="element-105">
            Presentamos
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold font-heading text-text-dark mb-4" data-id="element-106">
            El Método de la Pausa Consciente
          </h2>
          <p className="text-2xl font-heading italic text-gold-dark" data-id="element-107">
            El Interruptor de 3 Segundos
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-108">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="space-y-6 text-lg text-text-dark leading-relaxed" data-id="element-109">
            <p data-id="element-110">
              Este no es un libro de 300 páginas de teoría inalcanzable. Es un{' '}
              <strong className="text-text-dark font-bold" data-id="element-111">
                manual de intervención biológica
              </strong>{' '}
              diseñado para la vida real.
            </p>
            <p data-id="element-112">
              El corazón de este método es el{' '}
              <span className="bg-gold/20 px-2 py-1 rounded font-medium" data-id="element-113">
                Interruptor de 3 Segundos
              </span>
              : una técnica probada para desactivar la respuesta de "lucha o
              huida" en tu cuerpo justo antes de que el grito escape de tu boca.
            </p>
            <p data-id="element-114">
              Es el puente entre la mamá que reacciona por instinto y la mamá
              que guía con seguridad.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-115">
            <div className="absolute inset-0 bg-gold/10 rounded-full blur-3xl transform scale-90" data-id="element-116"></div>
            <img src="https://cdn.magicpatterns.com/uploads/hDUUN3WxeAvF2mT9CC7vYv/Cover.png" alt="El Método de la Pausa Consciente" className="relative z-10 w-3/4 mx-auto rounded-lg shadow-xl" data-id="element-117" />
          </motion.div>
        </div>
      </div>
    </section>;
}